type RuntimeConfig = {
  VITE_API_URL?: string;
  VITE_BASE_URL?: string;
  VITE_SECRET_KEY?: string;
  VITE_SLUG_URL?: string;
};

// config.js is loaded as the first script in index.html, so this object is
// populated before any module code runs. Falls back to Vite build-time values
// for local `vite dev` workflows where no container entrypoint runs.
const runtime: RuntimeConfig =
  (window as Window & { __RUNTIME_CONFIG__?: RuntimeConfig })
    .__RUNTIME_CONFIG__ ?? {};

export const VITE_API_URL: string =
  runtime.VITE_API_URL || import.meta.env.VITE_API_URL || '';

export const VITE_BASE_URL: string =
  runtime.VITE_BASE_URL || import.meta.env.VITE_BASE_URL || '';

export const VITE_SECRET_KEY: string =
  runtime.VITE_SECRET_KEY || import.meta.env.VITE_SECRET_KEY || '';

export const VITE_SLUG_URL: string =
  runtime.VITE_SLUG_URL || import.meta.env.VITE_SLUG_URL || '';
